import React, { Component } from 'react'
import { css } from 'aphrodite'
import { connect } from '@cerebral/react'
import styles from './styles'
import { state, signal } from 'cerebral/tags'
import { t } from '@billes/translator-client'

let getToggle = isMenuOpen => {
  if (isMenuOpen) {
    return 'm352 208c-26 0-48 22-48 48 0 26 22 48 48 48 26 0 48-22 48-48 0-26-22-48-48-48z m0-80l-192 0c-71 0-128 57-128 128 0 71 57 128 128 128l192 0c71 0 128-57 128-128 0-71-57-128-128-128z m0 208c-44 0-80-36-80-80 0-44 36-80 80-80 44 0 80 36 80 80 0 44-36 80-80 80z'
  }

  return 'm352 160c53 0 96 43 96 96 0 53-43 96-96 96l-192 0c-53 0-96-43-96-96 0-53 43-96 96-96l192 0m0-32l-192 0c-71 0-128 57-128 128 0 71 57 128 128 128l192 0c71 0 128-57 128-128 0-71-57-128-128-128z m-192 80c26 0 48 22 48 48 0 26-22 48-48 48-26 0-48-22-48-48 0-26 22-48 48-48m0-32c-44 0-80 36-80 80 0 44 36 80 80 80 44 0 80-36 80-80 0-44-36-80-80-80z'
}

export default connect(
  {
    open: state`node.tree.open`,
    toggleMenuOpen: signal`node.toggleMenuOpen`,
    showMenuToggle: state`node.showMenuToggle`
  },
  class Toggle extends Component {
    render() {
      const { showMenuToggle, toggleMenuOpen, open } = this.props
      if (!showMenuToggle) {
        return null
      }
      const fillStyle = css(
        open ? styles.fillStyleMenuVisible : styles.fillStyleMenuNotVisible,
        styles.toggleMenu
      )

      return (
        <div
          className={css(styles.toggleMenuContainer)}
          title={t('bms.header.titles.toggleMenu')}
        >
          <svg
            onClick={e => toggleMenuOpen()}
            className={fillStyle}
            viewBox={'0 0 512 512'}
          >
            <path d={getToggle(open)} />
          </svg>
        </div>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/NavigationBar/Toggle/toggle.js